<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="w-100 d-none" >
                <template #default>   <m-content-single-3 v-bind='{...{"contentLink":"banner-menu","contentType":"page"},...{}}' :style='""' class="col-12 m-0 p-0" ></m-content-single-3></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="mt-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-products-302 v-bind='{...{"paginate":false,"perPage":35,"productCardName":"mProductCard302","showSpecifiedCardFeature":""},...{}}' :style='""' class="container mb-5 pb-5" ></m-products-302></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mContentSingle3 from '@moeinmdn/miw-alpha-components/src/package/Content/Single/ContentSingle3'; import mProducts302 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products302/Products302';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mContentSingle3,mProducts302 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
